import {
  DeleteWorkSpaceDocument,
  DeleteWorkSpaceMutation,
  GetWorkSpaceDocument,
  WorkSpacesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { WorkSpace } from 'modules/space_control/hooks/useWorkSpace'

export const useDeleteWorkSpace = () => {
  const [executeMutation] = useMutation(DeleteWorkSpaceDocument, {
    extractorFn: (data: DeleteWorkSpaceMutation) =>
      data.spaceControlMutations.deleteSpacecontrolWorkSpace,
  })

  const deleteWorkSpace = async (workSpace: WorkSpace) => {
    if (!workSpace.id || !workSpace.workArea?.location?.id || !workSpace.workArea?.id) {
      throw new Error('WorkSpace must have valid id, workArea and location')
    }

    return executeMutation({
      variables: {
        id: workSpace.id,
      },
      refetchQueries: [
        {
          query: GetWorkSpaceDocument,
          variables: {
            id: workSpace.id,
          },
        },
        {
          query: WorkSpacesDocument,
          variables: {
            locationIds: [workSpace.workArea.location.id],
            workAreaIds: [workSpace.workArea.id],
          },
        },
      ],
      awaitRefetchQueries: true,
    })
  }

  return {
    deleteWorkSpace,
  }
}
